import { decryptData, defaulUrl } from "./const";

export const PrintFromApi = async (url, filename, setIsLoading) => {
    let status = 0;
    setIsLoading && setIsLoading(true); // sécurise si jamais tu n’as pas besoin de loader

    try {
        const response = await fetch(`${defaulUrl}${url}`, {
            method: "GET",
            headers: {
                Accept: "application/pdf",
                Authorization: `Bearer ${decryptData("ACCESS_TOKEN")}`,
            },
        });

        status = response.status;
        const data = await response.blob();

        if (setIsLoading) setIsLoading(false);

        if (status === 200) {
            const url = window.URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${filename}.pdf`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        if (setIsLoading) setIsLoading(false);
        console.error("Erreur lors du téléchargement :", error);
    }
};
